export default __webpack_public_path__ + "static/media/MEN-URINARY-TRACT-INFECTION.c417739f.png";